import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNotistComponent } from './simple-icons-notist.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNotistComponent ],
    exports:      [ SimpleIconsNotistComponent ],
    bootstrap:    []
})
export class SimpleIconsNotistModule {}
